var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L18.6603 5V15L10 20L1.33975 15V5L10 0Z",
    fill: "#8FE4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L1.33594 5.00391L10 0V3L4 6.5Z",
    fill: "#82D7F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 6.57031L18.6641 5.00391L10 0V3L16.0312 6.57031Z",
    fill: "#7BD0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 13.5156L1.33594 14.9961L10 20V17L3.9375 13.5156Z",
    fill: "#63B8DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L1.33742 5.00708L1.33594 15.0123L3.93401 13.5123L4 6.5Z",
    fill: "#89DEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0349 6.56618L18.6626 5.00708L18.6641 15.0123L16.066 13.5123L16.0349 6.56618Z",
    fill: "#73C8EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0664 13.5078L18.6641 14.9961L10 20V17L16.0664 13.5078Z",
    fill: "#6BC0E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7052 8.08801C11.6635 7.71777 11.4914 7.43097 11.189 7.2276C10.8865 7.02163 10.5059 6.91864 10.047 6.91864C9.71847 6.91864 9.43428 6.97079 9.19441 7.07508C8.95454 7.17676 8.76812 7.31755 8.63514 7.49746C8.50478 7.67475 8.4396 7.87682 8.4396 8.10365C8.4396 8.29398 8.48392 8.45824 8.57257 8.59643C8.66382 8.73462 8.78246 8.85064 8.92846 8.9445C9.07708 9.03576 9.23612 9.11267 9.4056 9.17525C9.57507 9.23522 9.73803 9.28475 9.89446 9.32386L10.6767 9.52723C10.9322 9.58981 11.1942 9.67454 11.4627 9.78144C11.7313 9.88834 11.9803 10.0291 12.2097 10.2038C12.4392 10.3785 12.6243 10.5949 12.7651 10.853C12.9085 11.1112 12.9802 11.4201 12.9802 11.7799C12.9802 12.2336 12.8629 12.6364 12.6282 12.9884C12.3962 13.3404 12.0585 13.6181 11.6153 13.8214C11.1746 14.0248 10.6415 14.1265 10.0157 14.1265C9.41603 14.1265 8.89718 14.0313 8.45915 13.841C8.02113 13.6507 7.67827 13.3808 7.43058 13.0314C7.18288 12.6794 7.046 12.2623 7.01993 11.7799H8.23232C8.25578 12.0693 8.34965 12.3105 8.5139 12.5035C8.68077 12.6938 8.89327 12.8359 9.15139 12.9297C9.41212 13.021 9.69761 13.0666 10.0079 13.0666C10.3494 13.0666 10.6532 13.0132 10.9191 12.9063C11.1877 12.7968 11.3989 12.6456 11.5527 12.4526C11.7065 12.2571 11.7834 12.0289 11.7834 11.7682C11.7834 11.5309 11.7157 11.3367 11.5801 11.1855C11.4471 11.0342 11.2659 10.9091 11.0365 10.81C10.8096 10.7109 10.5528 10.6236 10.266 10.548L9.31956 10.2899C8.67816 10.1152 8.16974 9.85836 7.79429 9.51941C7.42145 9.18046 7.23503 8.73201 7.23503 8.17405C7.23503 7.71256 7.36018 7.30973 7.61048 6.96557C7.86078 6.62141 8.19973 6.35416 8.62732 6.16383C9.05492 5.97089 9.53727 5.87442 10.0744 5.87442C10.6167 5.87442 11.0951 5.96959 11.5097 6.15992C11.9268 6.35025 12.2554 6.61228 12.4952 6.94602C12.7351 7.27714 12.8603 7.65781 12.8707 8.08801H11.7052Z",
    fill: "#82D7F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_146",
    x: 7.01993,
    y: 5.87442,
    width: 5.96027,
    height: 8.25208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.721569 0 0 0 0 0.858824 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_146"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondCoin);
export default __webpack_public_path__ + "static/media/DiamondCoin.e830d7353e3bced4663a0068b50dfbdb.svg";
export { ForwardRef as ReactComponent };